import React from 'react'
import { useSelector } from 'react-redux'

import ModalLayout from '@/app/component/layout/modal'

import { selectPersonalizationList } from '../../logs/store/selectors'
import UpdateSegmentForm from './form/update-segment-form'

type Props = {
  open: boolean
  segmentId: number
  onClose: () => void
  onSaved?: () => void
}

const UpdateSegmentDialog: React.FC<Props> = ({ open, segmentId, onClose, onSaved }) => {
  const pzList = useSelector(selectPersonalizationList)

  return (
    <ModalLayout title="Edit segment" isOpen={open} onClose={onClose}>
      <UpdateSegmentForm personalizationList={pzList} segmentId={segmentId} onExit={onClose} onSaved={onSaved} />
    </ModalLayout>
  )
}

export default UpdateSegmentDialog
